import React, { useContext } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Navigation from "../components/navigation"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { ViewportContext } from "../contexts/viewport-context"

const NichtGefundenPage = () => {
  const content = require("../data/not-found.json")["de"]
  useRedirectToLang("/404")
  const dimensions = useContext(ViewportContext)

  return (
    <>
      <Layout width={dimensions[0]}>
        <SEO title={`404: ${content[0]}`} />
        <div className="not-found">
          <h1>{content[0]}</h1>
          <p>{content[1]}</p>
        </div>
      </Layout>
      <Navigation path="/404" width={dimensions[0]} />
    </>
  )
}

export default NichtGefundenPage
